import BMP from 'bmp-js';
import ExifReader from 'exifreader';
import { filetypeextension } from 'magic-bytes.js';

interface ImageMetadata {
  width: number;
  height: number;
  channels: number | undefined;
  colorType: number | undefined;
}

interface IMetaValue {
  value: number | undefined;
}

interface IJpgMetadata {
  'Image Width': IMetaValue;
  'Image Height': IMetaValue;
  'Color Components': IMetaValue;
  colorType: IMetaValue;
}

export function decodeImage(data: ArrayBuffer | SharedArrayBuffer): ImageMetadata {
  const buffer = Buffer.from(data);
  const metadata: ImageMetadata = { width: 0, height: 0, channels: undefined, colorType: undefined };
  const extensions = filetypeextension(buffer);

  if (['jpg', 'jpeg'].some((item) => extensions.includes(item))) {
    const jpg = ExifReader.load(buffer) as unknown as IJpgMetadata;
    metadata.height = jpg['Image Height'].value ?? 0;
    metadata.width = jpg['Image Width'].value ?? 0;
    metadata.channels = jpg['Color Components'].value ?? 0;
    return metadata;
  }
  if (['png'].some((item) => extensions.includes(item))) {
    const png = ExifReader.load(buffer) as unknown as IJpgMetadata;
    metadata.height = png['Image Height'].value ?? 0;
    metadata.width = png['Image Width'].value ?? 0;
    metadata.colorType = (png.colorType as unknown as number) ?? 0;
    return metadata;
  }
  if (['bmp'].some((item) => extensions.includes(item))) {
    const bmp = BMP.decode(buffer);
    metadata.height = bmp.height;
    metadata.width = bmp.width;
    return metadata;
  }

  throw new Error('Not supported file type', { cause: extensions.find(() => true)?.toLocaleUpperCase() });
}
